import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/AuthShell";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setLink(window.location.origin + data.reset_path);
    } catch (err) {
      setError(errMsg(err));
    }
  };

  return (
    <AuthShell title="Forgot password?" subtitle="Enter your registered email and we'll create a reset link.">
      {!link ? (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="femail">Registered email</Label>
            <Input id="femail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
          <Button type="submit" className="w-full h-11 bg-[#3B185F] hover:bg-[#250E3F]" data-testid="forgot-submit-btn">Send reset link</Button>
        </form>
      ) : (
        <div className="space-y-4 rounded-xl border border-[#D4AF37]/50 bg-[#FFFDF0] p-5" data-testid="reset-link-box">
          <p className="text-sm font-semibold text-[#19082B]">Your reset link is ready</p>
          <p className="text-xs text-stone-600">Use the secure link below to choose a new password. It expires in 1 hour.</p>
          <a href={link} className="block break-all font-mono text-xs text-[#3B185F] underline" data-testid="reset-link">{link}</a>
          <Button asChild className="w-full bg-[#D4AF37] text-[#19082B] hover:bg-[#C59B27]" data-testid="open-reset-link-btn">
            <a href={link}>Open reset link</a>
          </Button>
        </div>
      )}
      <Link to="/login" className="block text-sm font-semibold text-[#3B185F]" data-testid="back-to-login-link">← Back to login</Link>
    </AuthShell>
  );
}
